module.exports = __webpack_public_path__ + "img/pic_top.9635b631.png";